import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const contactRowStyle = () => ({
	row: {
		display: 'inline-flex',
		alignItems: 'center',
		marginTop: '5px',
		flexWrap: 'wrap',
		padding: '10px 0',
		'& > p': {
			margin: '3px 5px 0 0',
		},
		'& svg': {
			color: blackColors[4],
			fontSize: '16px',
			marginRight: '9px',
			marginBottom: '1px',
			maxHeight: '16px',
		},
		'& > div > p': {
			textAlign: 'center',
			whiteSpace: 'nowrap',
		},
	},
});

export default contactRowStyle;
